import { useNavigate } from "react-router-dom";

import { CampaignForm } from "containers/admin/clients/campaign/components/campaign-form/campaign-form";
import toast from "components/partials/toast/toast";

import {
  CampaignAttributes,
  CampaignWriteBody,
  useCurrentCampaign,
  useReplaceCampaign,
} from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";

import { getErrorMessage } from "utilities";
import { usePagePermission } from "hooks/use-page-permission";

import { Permission } from "types/auth";

const CampaignSettingsEditPage = () => {
  const client = useCurrentClient();
  const navigate = useNavigate();
  const campaign = useCurrentCampaign();
  const replaceCampaignMutation = useReplaceCampaign();

  usePagePermission(Permission.PERM_CAMPAIGN_WRITE);

  const updateCampaign = async (attributes: CampaignWriteBody & { id: string }) => {
    try {
      const { id, ...data } = attributes;
      return await replaceCampaignMutation.mutateAsync({
        clientId: client.id,
        id,
        data,
      });
    } catch (err) {
      toast.error({
        data: {
          title: "Failed to edit campaign",
          message: getErrorMessage(err?.response?.data),
        },
      });
      throw err;
    }
  };

  const handleSuccess = async (campaignAfterUpdating: CampaignAttributes) => {
    toast.success({
      data: {
        title: "Updated campaign",
      },
    });
    navigate(`/clients/${client.id}/campaigns/${campaignAfterUpdating.id}/settings`);
  };

  const cancelEditCampaign = () => {
    navigate(`/clients/${client.id}/campaigns/${campaign.id}`);
  };

  return (
    <CampaignForm
      campaign={campaign}
      onCancel={cancelEditCampaign}
      onSubmit={updateCampaign}
      onSuccess={handleSuccess}
    />
  );
};

export default CampaignSettingsEditPage;
